var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{},[_c('vs-button',{attrs:{"size":"small"},on:{"click":function($event){return _vm.$router.push('/recipes/recipe/view/1')}}},[_vm._v("Ver")])],1)}
var staticRenderFns = []

export { render, staticRenderFns }